import { ShowSession, ShowSessionType } from '../stores/reducers/session';
import { getAuthenticatedRequestInit } from './utils';

export const GetShowSessionTypes = (token: string): Promise<ShowSessionType[]> => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/show-sessions/types`, {
		method: 'GET',
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			return [];
		}
	});
};

export const GetShowSessionsByMeetingId = (token: string, meetingId: number): Promise<ShowSession[]> => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/meetings/${meetingId}/show-sessions`, {
		method: 'GET',
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			throw new Error('Could not load show sessions.');
		}
	});
};

export const AddShowSession = (token: string, showSession: ShowSession): Promise<ShowSession[]> => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/show-sessions`, {
		method: 'POST',
		body: JSON.stringify(showSession),
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (result.ok) {
			return GetShowSessionsByMeetingId(token, showSession.meeting);
		} else {
			throw new Error('Could not add show session.');
		}
	});
};

export const EditShowSession = (token: string, showSession: ShowSession): Promise<ShowSession[]> => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/show-sessions`, {
		method: 'PUT',
		body: JSON.stringify(showSession),
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (result.ok) {
			return GetShowSessionsByMeetingId(token, showSession.meeting);
		} else {
			throw new Error('Could not edit show session.');
		}
	});
};

export const DeleteShowSession = (token: string, showSession: ShowSession): Promise<ShowSession[]> => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/show-sessions`, {
		method: 'DELETE',
		body: JSON.stringify({ id: showSession.id }),
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (result.ok) {
			return GetShowSessionsByMeetingId(token, showSession.meeting);
		} else {
			throw new Error('Could not delete show session.');
		}
	});
};
